import React from 'react';
import { Zap } from 'lucide-react';
import Reveal from './Reveal';
import { photos } from '../photos';

const TILES = [
  { photo: 'bowl', alt: 'bowl' },
  { photo: 'lift', alt: 'lift' },
  { photo: 'fresh', alt: 'fresh' },
  { photo: 'gym', alt: 'gym' },
  { photo: 'hiit', alt: 'hiit' },
  { photo: 'yoga', alt: 'yoga' },
];

export default function Platform({ t }) {
  const p = t.platform;

  return (
    <section id="platform" className="scroll-mt-24 bg-pine text-paper py-20 lg:py-28">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-10">
        <Reveal>
          <p className="font-display text-xs tracking-[0.32em] uppercase text-ember">03 — {p.kicker}</p>
          <h2 className="mt-4 font-display uppercase text-4xl sm:text-5xl lg:text-6xl leading-[0.92] max-w-4xl">
            {p.title}
          </h2>
          <p className="mt-5 text-lg text-paper/70 max-w-2xl leading-relaxed">{p.sub}</p>
        </Reveal>

        <Reveal>
          <div className="mt-12 grid lg:grid-cols-5 min-h-[340px] bg-pineDeep overflow-hidden">
            <div className="lg:col-span-2 relative min-h-[260px]">
              <img src={photos.lift} alt={t.media.lift} className="absolute inset-0 w-full h-full object-cover" />
            </div>
            <div className="lg:col-span-3 p-8 sm:p-10 flex flex-col justify-center">
              <span className="inline-flex items-center gap-2 w-fit px-3 py-1 bg-ember text-ink text-[11px] font-bold uppercase tracking-[0.16em]">
                <Zap size={12} fill="currentColor" />
                {p.coachPill}
              </span>
              <h3 className="mt-5 font-display text-4xl sm:text-5xl uppercase leading-none">{p.coachTitle}</h3>
              <p className="mt-4 text-paper/75 leading-relaxed max-w-xl">{p.coachDesc}</p>
            </div>
          </div>
        </Reveal>

        <div className="mt-4 grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {p.items.map((item, i) => (
            <Reveal key={item.title} delay={(i % 3) * 70}>
              <article className="bg-cream text-ink h-full overflow-hidden">
                <div className="h-40 overflow-hidden">
                  <img
                    src={photos[TILES[i].photo]}
                    alt={t.media[TILES[i].alt]}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="p-6">
                  <h3 className="font-display text-2xl uppercase leading-none">{item.title}</h3>
                  <p className="mt-3 text-sm text-stone leading-relaxed">{item.desc}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
